import { useNavigate } from "react-router-dom"
import "../styles/portal/ShapeDetalhe.css"
import Select from "react-select";
import { downloadFile, readShapefiles } from "../aws/Authentication";
import {
  GoogleMap,
  useLoadScript,
  Polygon,
} from "@react-google-maps/api";
import { useContext, useEffect, useRef, useState } from "react";
import { PortalContext } from "../Portal";
import { criaArrayPoligonosUnificado, criaArrayPoligonosUnificadoFundido, organizaShape } from "./processadorPoligonos.worker";
import Legenda from "./Legenda";
import Botao from "../utils/Botao";
import { deleteShapefileAPI, updateShapefilePermission } from "../aws/Api";

const libraries = ["places"];
const mapContainerStyle = {
  flex: "1",
  "alignSelf": "center",
//   "max-width": "800px",
//   "max-height": "1000px",
    height: "600px",
};

function ShapeDetalhe() {
    const { devices, user, campoEscolhido, setShpData, setShxData, setDbfData, dbfData, shpData, identityId, shapefile } = useContext(PortalContext);
    const navigate = useNavigate();
    const [coluna, setColuna] = useState(0);    
    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("");
    const [options, setOptions] = useState();
    const [selectedOptions, setSelectedOptions] = useState();
    // const [map, setMap] = useState(null);
    const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_MAPS_JS_KEY
    // const GOOGLE_STATIC_KEY = process.env.REACT_APP_GOOGLE_STATIC_MAPS_KEY
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: GOOGLE_KEY,
        libraries,
    });
    const handleOnClickVoltar = () => {        
        setShpData(null);
        setDbfData(null);
        navigate("/portal/mapas");
    }    
    const [path, setPath] = useState([]);
    const [defaultCenter, setCenter] = useState({
            lat: -15.793889, lng: -47.882778
        });
    const [defaultZoom, setZoom] = useState(5);
    const mapRef = useRef(null);
    const onLoad = (map) => {
        mapRef.current = map;
        // setMap(map);
        // console.log("Chamou onLoad");
    };
    /* const options = [
        {value: "xxx", label: "tablet01 (id:xxxx)"},
        {value: "yyy", label: "tablet02 (id:yyy)"},
        {value: "zzz", label: "tablet03 (id:zzz)"}
    ]; */
    const handlePermissionChange = (selectedOptions, shapefile) => {
        // console.log(selectedOptions);
        const deviceIDs = (selectedOptions || []).map(opt => opt.value);
        updateShapefilePermission(shapefile.shapefileUUID, user.username, deviceIDs);
    }
    useEffect(() => {
        // console.log("início do useEffect com lat lon ref = ", parseFloat(campoEscolhido.latRef), ", ", parseFloat(campoEscolhido.lonRef));
        if (!shapefile)
        {
            console.log("Não tem shapefile");
            navigate("/portal/home");
            return;
        }
        if (devices != null) {
            const options = devices.map((device) => ({value: device.deviceID, label: device.deviceName}));
            setOptions(options);
            const deviceIDs = shapefile.deviceID || [];  // array
            setSelectedOptions(options.filter(opt => deviceIDs.includes(opt.value)));
        }
        async function processar() {
            try {
                // Verifica se já existe shpData/dbfData
                if (!shpData && !dbfData) {
                    // console.log("Não tem shpData, vai buscar");
                    setLoading(true);
                    setLoadingMessage("Baixando arquivos...");

                    // 1) Baixar arquivos
                    const [shpSignedURL, shxSignedURL, dbfSignedURL] = await Promise.all([
                        readShapefiles(shapefile.shapefileUUID + ".shp"),
                        readShapefiles(shapefile.shapefileUUID + ".shx"),
                        readShapefiles(shapefile.shapefileUUID + ".dbf"),
                    ]);

                    const [shpBinary, shxBinary, dbfBinary] = await Promise.all([
                        shpSignedURL.Body.arrayBuffer(),
                        shxSignedURL.Body.arrayBuffer(),
                        dbfSignedURL.Body.arrayBuffer(),
                    ]);

                    // 2) Processar binários
                    setLoadingMessage("Processando dados (aguarde)...");
                    await new Promise(r => setTimeout(r, 10)); // garante repaint do overlay

                    const { shpObj, dbfObj } = organizaShape(shpBinary, shxBinary, dbfBinary);
                    // console.log("shpObj = ", shpObj, ", dbfObj = ", dbfObj);
                    // 3) Criar polígonos da coluna escolhida
                    const data = criaArrayPoligonosUnificado(shpObj, dbfObj, coluna);

                    // 4) Atualizar estados
                    setShpData(shpObj);
                    setDbfData(dbfObj);
                    setCenter({
                        lat: shpObj.boxYmin + (shpObj.boxYmax - shpObj.boxYmin) / 2,
                        lng: shpObj.boxXmin + (shpObj.boxXmax - shpObj.boxXmin) / 2,
                    });
                    /* map.panTo({
                        lat: shpObj.boxYmin + (shpObj.boxYmax - shpObj.boxYmin) / 2,
                        lng: shpObj.boxXmin + (shpObj.boxXmax - shpObj.boxXmin) / 2,
                    });
                    map.setZoom(16); */
                    setZoom(15);
                    setPath(data);
                    setLoading(false);
                    setLoadingMessage('');
                } 
                else {
                    // Já tem os dados baixados → só reprocesa a coluna
                    // console.log("Reprocessando coluna com dados já em memória");
                    setLoading(true);
                    setLoadingMessage("Atualizando visualização com " + dbfData.numOfRecords + " polígonos");
                    await new Promise(r => setTimeout(r, 100));

                    // const dataAntes = criaArrayPoligonosUnificado(shpData, dbfData, coluna);
                    // console.log("Resultado do criaArrayPoligonosUnificado = ", dataAntes);
                    let tolerancia = 0; // percentual de tolerancia usado para fundir poligonos
                    if (coluna === 2)
                        tolerancia = 3; // Como a velocidade ´e baixa e muda muito ap´os a virgula, colocamos uma tolerancia de 3¢
                    const data = criaArrayPoligonosUnificado(shpData, dbfData, coluna, tolerancia);
                    // console.log("Resultado do criaArrayPoligonosUnificadoFundido = ", data);
                    setCenter({
                        lat: shpData.boxYmin + (shpData.boxYmax - shpData.boxYmin) / 2,
                        lng: shpData.boxXmin + (shpData.boxXmax - shpData.boxXmin) / 2,
                    });
                    setZoom(15);
                    setPath(data);
                    
                    setLoading(false);
                    setLoadingMessage('');
                }
            } catch (error) {
                console.error("Erro ao processar:", error);                
                setLoading(true);
                setLoadingMessage("Erro ao carregar/processar arquivos: " + error);
            }
        }

        processar();
    }, [dbfData, coluna]);
    if (loadError) {
        return <div>Error loading maps</div>;
    }

    if (!isLoaded) {
        return <div>Loading maps</div>;
    }
    const handleGetFile = (fileKey, filename) => {
    downloadFile(fileKey + ".dbf", filename + ".dbf")
    .then((data) => {
      downloadFile(fileKey + ".shp", filename + ".shp")
      .then((data) => {
        downloadFile(fileKey + ".shx", filename + ".shx")
        .catch(err => console.log(err));
      })
      .catch(err => console.log(err));
    })
    .catch(err => console.log(err));
  }
    const botoesStyle = {
            width: "120px", 
            height: "50px", 
            "fontWeight": "normal"
        }
    const handleDelete = async () => {
        const confirmacao = window.confirm(
            "Tem certeza que deseja excluir esse mapa?"
        );

        if (!confirmacao) {
            // console.log("pressionou nao");
            return;
        }

        // console.log("pressionou sim");

        try {
            deleteShapefileAPI(shapefile.shapefileUUID, user.username, identityId).then(res => {
                if(!res.ok) throw Error("Não conseguiu buscar");
                return res.json();
            }).then(data => {
                // console.log("Retorno do delete events ", data);
                alert("Evento excluído com sucesso!");
                handleOnClickVoltar();
            }).catch(err => {
                console.log("Catch do TrabalhoDetalhe Depois de pedir pra deletar evento ", err);
            });
            //onDelete(evento.id); // Atualiza a lista no front
        } catch (error) {
            console.error("Erro:", error);
            alert("Falha ao excluir o evento.");
        }        
    };
    return (
        <div className="shape-detalhe-container">
            {/* <Link to="/portal/mapas">Voltar</Link> */}
            <div className="shape-detalhe-tittle-container">
                <Botao handleOnClick={() => handleOnClickVoltar()} estilo={{width: "100px", height: "50px"}}>Voltar</Botao>
                <div className="tittle">{shapefile.filename}</div>
            </div>
            <div className="shape-detalhe-infos-container">
                <div className="shape-detalhe-map-container">
                    {loading && <h3 style={{"justifySelf": "center"}}>{loadingMessage}</h3>}
                    <GoogleMap
                        mapContainerStyle={mapContainerStyle}
                        zoom={defaultZoom}
                        center={defaultCenter} // É bom ter uma propriedade de centro definida
                        mapTypeId="satellite"
                        onLoad={onLoad} // aqui vinculamos o mapa ao ref
                    >
                        {path.length > 0 && path.map((poligono, index) => (
                            <Polygon
                            key={index}
                            path={poligono.points}
                            options={{
                                fillColor: poligono.rgb,
                                strokeWeight: 0,
                                fillOpacity: 0.7,
                            }}
                            />
                        ))}
                    </GoogleMap>
                    {dbfData && (<Legenda style={{"left": "10px"}} tipo="generic" min={dbfData.limites[coluna].limiteMin} max={dbfData.limites[coluna].limiteMax} />)}
                </div>
                <div className="shape-detalhe-dropdown-container">
                    <div className="shape-detalhe-dropdown">
                        <h3>coluna:</h3>
                        <select value={coluna} onChange={(e) => {
                            const v = parseInt(e.target.value, 10); // converte mesmo que venha "0"
                            setColuna(Number.isNaN(v) ? 0 : v);     // fallback seguro
                        }}>
                            {dbfData && dbfData.records.map((coluna) => (
                                <option value={coluna.index}>{coluna.nomeColuna}</option>
                            ))}
                        </select>
                    </div>
                    <div className="shape-detalhe-dropdown">
                        <h3>Nível de permissão</h3>
                        <Select 
                            className="shape-detalhe-dropdown" 
                            options={options} 
                            onChange={(opts) => {
                                setSelectedOptions(opts);
                                handlePermissionChange(opts, shapefile);
                            }} 
                            value={selectedOptions} isMulti
                        /> 
                    </div>
                </div>
                <div className="shape-detalhe-botoes-container">
                    {/* <button className="shape-detalhe-botoes" onClick={() => handleGetFile(shapefile.shapefileUUID, shapefile.filename)}>Download</button> */}
                    <Botao handleOnClick={() => handleGetFile(shapefile.shapefileUUID, shapefile.filename)} estilo={botoesStyle}>Download</Botao>
                    <Botao handleOnClick={() => handleDelete(shapefile.shapefileUUID)} estilo={botoesStyle}>Excluir</Botao>
                </div>
            </div>
        </div>
    )
}

export default ShapeDetalhe
